/**
 * Extract a short voice snippet from a completed segment (for voice continuity).
 * @param {Function} hitAxios
 * @param {string} videoUrl
 */
export async function extractVoiceSnippet(hitAxios, videoUrl) {
  const res = await hitAxios({
    path: "/api/video-studio/extract-voice-snippet",
    post: true,
    obj: { video_url: videoUrl },
    showLoading: false,
    showSnackbar: false,
    timeout: 120000,
  });

  if (!res?.data?.success) {
    throw new Error(res?.data?.msg || "Could not extract voice from previous clip.");
  }

  const url = res.data.data?.audio_url;
  if (!url) throw new Error("Server did not return a voice snippet URL.");
  return url;
}
